const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGOUT: 'LOGOUT',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  USER2_LOGIN_REQUEST: 'USER2_LOGIN_REQUEST',
  USER2_LOGIN_SUCCESS: 'USER2_LOGIN_SUCCESS',
  USER2_LOGIN_ERROR: 'USER2_LOGIN_ERROR',
  USER2_LOGOUT: 'USER2_LOGOUT',
  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),
  login: (token = false) => ({
    type: actions.LOGIN_REQUEST,
    token,
  }),
  logout: () => ({
    type: actions.LOGOUT,
  }),
};
export default actions;
